export default __webpack_public_path__ + "static/media/Mace of the Blood God.a9ca1639.jpg";